<template>
  <b-navbar type="light" variant="light">
    <router-link to="/">
      <img src="@/assets/logo.png" width="150" alt="BuzzPoint Logo" />
    </router-link>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template v-slot:button-content>
            <!-- <span :class="`flag-icon flag-icon-${$i18n.locale}`"></span> -->
            <span
              class="d-sm-inline-block"
              :aria-label="$t('chosenLanguage') + ' ' + getLang($i18n.locale)"
            >
              {{ getLang($i18n.locale) }}
            </span>
          </template>
          <template>
            <b-dropdown-item
              v-for="(lang, i) in filteredLangs"
              :key="i"
              @click="changeLocale(lang)"
            >
              <!-- <span :class="`flag-icon flag-icon-${lang}`"></span> -->
              <span :aria-label="$t('chosenLanguage') + ' ' + getLang(lang)">
                {{ getLang(lang) }}
              </span>
            </b-dropdown-item>
          </template>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown no-caret right>
          <template v-slot:button-content>
            <v-icon>mdi-menu</v-icon>
          </template>
          <template>
            <b-dropdown-item
              v-for="(link, i) in links"
              :key="i"
              @click="goTo(link.route)"
            >
              <font-awesome-icon :icon="link.icon" />
              <span> &nbsp;&nbsp;{{ $t(link.title) }} </span>
            </b-dropdown-item>
          </template>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      langs: ["ru", "gb"],
      langsTmp: [],
      outlined: true,
      flat: true,
      elevation: undefined,
      source: "https://sibel.by",
      dialog: false,
      drawer: false,
      group: null,
      links: [
        {
          // icon: "mdi-home",
          icon: "home",
          title: "homeLink",
          route: "/"
        },
        {
          // icon: "mdi-magnify",
          icon: "search",
          title: "pointsLink",
          route: "/points"
        }
      ]
    };
  },
  methods: {
    getLang(lang) {
      switch (lang) {
        case "gb":
        case "en":
          return "EN";
        case "ru":
          return "РУ";
        default:
          return "EN";
      }
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
    },
    goTo(link) {
      if (this.$route.path !== link) this.$router.push(link);
    }
  },
  watch: {
    group() {
      this.drawer = false;
    }
  },
  computed: {
    filteredLangs() {
      let langsTmp = JSON.parse(JSON.stringify(this.langs));
      if (this.$i18n.locale === "ru") {
        langsTmp.splice(this.langs.indexOf("ru"), 1);
      } else {
        langsTmp.splice(this.langs.indexOf("gb"), 1);
      }
      return langsTmp;
    }
  }
};
</script>

<style lang="css" scoped>
a:link {
    text-decoration: none;
}

.menuLink {
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    position: absolute;
    z-index: 1;
}
</style>
<style>
.dropdown-menu {
  min-width: auto !important;
}
</style>
